// extracted by mini-css-extract-plugin
export default {"input":"text-input_input__XuK-Y","grouped":"text-input_grouped__EdRcw","suffix":"text-input_suffix__UTsI+"};